/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
import { batchActions } from 'redux-batched-actions';
//actions
import { displayModal, sendMessage } from '@insticator/insticator-ui'; // iui-utils
import { updateMultipleFormFields } from'state/actions/embedsState/embedManagementState/form_data';
import { setEmbedProperties } from 'state/actions/embedsState/embedManagementState/selected_embed_status';
import { resetForm, receiveFormData, invalidateForm, setFieldValidation } from '@insticator/insticator-ui';
import { resetEmbedState, attachLabel, removeLabel } from 'state/actions/embedsState/embedManagementState/selected_embed_status';
import { resetContentState } from 'state/actions/embedsState/embedManagementState/content_status';
import { updatePageDetails, changePage } from '@insticator/insticator-ui';
import { updateStepDetails } from 'state/actions/embedsState/embedManagementState/embed_management_status';
import { discardContentChanges } from 'state/actions/embedsState/embedManagementState/content_status';
import { discardEmbedChanges } from 'state/actions/embedsState/embedManagementState/selected_embed_status';
// component
import EditEmbedName from 'pages/dashboard/embeds/management/editembedname/editembedname';



/* ========== ~~~~~~~~~~ EMBED EDIT NAME : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ embedsState, accountData, sessionStatus }) => {
    const embedToSiteUUID ={};
    const clientEmbedNames = embedsState.embedsStatus.clientEmbeds.map(embed => {
        embedToSiteUUID[embed.embedName] = embed.siteUUID
        return embed.embedName;
    });
    return {
    embeds: embedsState.embedsStatus.clientEmbeds,
    sites: accountData.sites,
    savingData: embedsState.embedManagementState.selectedEmbedStatus.editembedname.savingData,
    fields: embedsState.embedManagementState.selectedEmbedStatus.editembedname.fields,
    embedUUID: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.embedUUID,
    embedName: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.embedName,
    siteURL: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.siteURL,
    siteUUID: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.siteUUID,
    isNewEmbedFlow: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.isNewEmbedFlow,
    isSavingData: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.isSavingData,
    embedChangeDetected: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.embedChangeDetected,
    attachedLabelUUIDs: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.attachedLabelUUIDs,
    mockupGenerator: sessionStatus.mockupGenerator,
    mockedSiteUUID: sessionStatus.siteUUID,
    embedNames: embedsState.embedsStatus.embedNames,
    clientEmbedNames,
    embedToSiteUUID
}};

// map actions
const mapDispatchToProps = dispatch => ({
    updateMultipleFormFields: formData => dispatch(updateMultipleFormFields(formData)),
    setEmbedProperties: properties => dispatch(setEmbedProperties(properties)),
    displayModal: bool => dispatch(displayModal(bool)),
    resetForm: formName => dispatch(resetForm(formName)),
    receiveFormData: (formName, formData) => dispatch(receiveFormData(formName, formData)),
    invalidateForm: formName => dispatch(invalidateForm(formName)),
    sendMessage: message => dispatch(sendMessage(message)),
    setFieldValidation: (formName, fieldName, validationStatus) => dispatch(setFieldValidation(formName, fieldName, validationStatus)),
    moveToEmbedCreationWithStateReset: (embedInitialData) => {
        dispatch(batchActions([
            resetEmbedState(embedInitialData),
            resetContentState({ setInitialContentId: true })
        ]));
        dispatch(updatePageDetails('dashboard/embeds/management/placement'));
        dispatch(updateStepDetails('placement'));
        dispatch(changePage('dashboard/embeds/management/placement'))
    },
    discardChanges: () => dispatch(batchActions([
        discardContentChanges(),
        discardEmbedChanges()
    ])),
    attachLabel: (labelUUID) => dispatch(attachLabel(labelUUID)),
    removeLabel: (labelUUID) => dispatch(removeLabel(labelUUID))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EditEmbedName);
